const mediaItems = [
  {
    id: 'media-1',
    title: '流浪地球3：终极预告震撼发布',
    desc: '人类命运迎来最终抉择，太阳危机真相浮出水面。国产科幻里程碑系列终章，视效全面升级。',
    duration: '2:38',
    category: '预告片',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20teaser%20visual%2C%20massive%20spaceship%20entering%20wormhole%2C%20orange%20and%20blue%20cosmic%20colors%2C%20dramatic%20wide%20shot%2C%20epic%20space%20opera%20aesthetic%2C%20film%20grain%20texture%2C%20high%20contrast%20cinematic%20lighting&width=800&height=450&seq=juzi-media-01&orientation=landscape',
  },
  {
    id: 'media-2',
    title: '繁花似锦：幕后制作特辑',
    desc: '王家卫导演亲述创作心路，揭秘上海滩场景搭建背后的匠心。看胡歌如何诠释商海传奇人物。',
    duration: '15:20',
    category: '特辑',
    img: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20production%20visual%2C%20director%20chair%20on%20movie%20set%20with%20warm%20lighting%2C%20vintage%20Shanghai%20street%20set%20design%2C%20cinematic%20camera%20equipment%2C%20golden%20hour%20atmosphere%2C%20film%20production%20aesthetic&width=800&height=450&seq=juzi-media-02&orientation=landscape',
  },
  {
    id: 'media-3',
    title: '山河令：仙侠世界概念设计',
    desc: '揭秘剧中瑰丽奇幻场景的诞生过程，从概念草图到最终成片，看东方美学如何化为视觉盛宴。',
    duration: '8:45',
    category: '花絮',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20film%20concept%20art%20visual%2C%20floating%20mountains%20with%20waterfalls%2C%20ancient%20Chinese%20architecture%2C%20ethereal%20mist%20and%20glowing%20lanterns%2C%20soft%20dreamy%20lighting%2C%20traditional%20ink%20painting%20aesthetic%20blended%20with%20cinematic%20style&width=800&height=450&seq=juzi-media-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50">精彩预告</h2>
          <p className="text-foreground-500 text-sm mt-2">最新预告片、幕后特辑与独家花絮</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-300/30 cursor-pointer hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-background-50/30 group-hover:bg-background-50/20 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-400 transition-colors">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2.5 py-1 rounded-md bg-background-50/85 text-foreground-50 text-xs font-medium whitespace-nowrap">
                  {item.duration}
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-md bg-accent-500/85 text-background-50 text-[10px] font-bold whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-foreground-100 font-bold text-sm">{item.title}</h3>
                <p className="text-foreground-600 text-xs mt-1.5 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}